<div class="loader-wrapper">
  <app-shimmer-loader
    [theme]="{
        'height': '5rem'
      }"
    appearance="line"
  />
  <div
    class="flex flex-col w-full space-y-[1rem] lg:px-[8rem] xs:px-0 sm:px-0 pt-[3.2rem]"
  >
    <div
      class="flex lg:flex-row w-full justify-center items-center lg:space-x-[1.5rem] xs:space-x-0 sm:space-x-0 xs:flex-col sm:flex-col"
    >
      <div
        class="lg:w-[30%] xs:w-full sm:w-full"
      >
        <app-shimmer-loader
          class="mb-[0.4rem]"
          [theme]="{
            'height': '1.4rem',
            'width': '50%'
          }"
          appearance="line"
        />
        <app-shimmer-loader
          [theme]="{
            'height': '3.6rem'
          }"
          appearance="line"
        />
      </div>
      <div
        class="lg:w-[18%] xs:w-full sm:w-full"
      >
        <app-shimmer-loader
          class="mb-[0.4rem]"
          [theme]="{
            'height': '1.4rem',
            'width': '50%'
          }"
          appearance="line"
        />
        <app-shimmer-loader
          [theme]="{
            'height': '3.6rem'
          }"
          appearance="line"
        />
      </div>
      <div
        class="lg:w-[17%] min-w-[17%] xs:w-full sm:w-full"
      >
        <app-shimmer-loader
          class="mb-[0.4rem]"
          [theme]="{
            'height': '1.4rem',
            'width': '50%'
          }"
          appearance="line"
        />
        <app-shimmer-loader
          [theme]="{
            'height': '3.6rem'
          }"
          appearance="line"
        />
      </div>
      <div
        class="flex lg:flex-row lg:w-[35%] space-x-[1.5rem] xs:w-full sm:w-full"
      >
        <div
          class="w-[50%] min-w-[50%]"
        >
          <app-shimmer-loader
            class="mb-[0.4rem]"
            [theme]="{
            'height': '1.4rem',
            'width': '50%'
          }"
            appearance="line"
          />
          <app-shimmer-loader
            [theme]="{
            'height': '3.6rem'
          }"
            appearance="line"
          />
        </div>
        <div
          class="w-[50%]"
        >
          <app-shimmer-loader
            class="mb-[0.4rem]"
            [theme]="{
            'height': '1.4rem',
            'width': '50%'
          }"
            appearance="line"
          />
          <app-shimmer-loader
            [theme]="{
            'height': '3.6rem'
          }"
            appearance="line"
          />
        </div>
      </div>
    </div>
    <div
      class="flex flex-col justify-start"
    >
      <app-shimmer-loader
        class="w-3/12"
        [theme]="{
          'height': '1.8rem'
        }"
        appearance="line"
      />
      <div
        class="flex md:flex-row w-full xs:flex-col sm:flex-col gap-[1.4rem]"
      >
        <app-shimmer-loader
          class="w-2/12"
          [theme]="{
            'height': '1.8rem'
          }"
          appearance="line"
        />
        <app-shimmer-loader
          class="w-2/12"
          [theme]="{
            'height': '1.8rem'
          }"
          appearance="line"
        />
        <app-shimmer-loader
          class="w-2/12"
          [theme]="{
            'height': '1.8rem'
          }"
          appearance="line"
        />
      </div>
    </div>
    <div
      class="flex flex-col"
    >
      <app-shimmer-loader
        class="w-3/12"
        [theme]="{
          'height': '1.8rem'
        }"
        appearance="line"
      />
      <app-shimmer-loader
        [theme]="{
          'height': '10rem'
        }"
        appearance="line"
      />
    </div>
    <div
      class="flex row w-full justify-end"
    >
      <app-shimmer-loader
        class="w-3/12"
        [theme]="{
          'height': '3.6rem'
        }"
        appearance="line"
      />
    </div>
  </div>
</div>
